import { graphql, useStaticQuery } from 'gatsby'

export const useSiteMetadata = (): Queries.SiteMetadata => {
    const data = useStaticQuery(graphql`
    query {
        site {
            siteMetadata {
                title
                slogan
                siteUrl
                description
                companyName
                contactFormEndpoint
                reCaptchaSiteKey
                socialLinks {
                    name
                    url
                }
                navLinks {
                    name
                    url
                }
            }
        }
    }
  `)

    return data.site.siteMetadata
}
